import React, { Component } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
// import { Row, Col } from "react-bootstrap";
// import { IoFunnel } from "react-icons/io5";
import { debounce } from "lodash";

import * as modalActions from "../../actions/modalActions";
import * as expenseActions from "../../actions/expenseActions";
import * as userActions from "../../actions/userActions";
import * as contractActions from "../../actions/contractActions";

import HeaderWrapper from "../common/HeaderWrapper";
import ConfirmModal from "../common/ConfirmModal";
import Loading from "../common/Loading";
import ExpenseList from "./ExpenseList";
// import FiltersComponent from "../common/FiltersComponent";
import ExpenseService from "../../services/expenseService";

const getFilters = (initialValue) => {
  const item = localStorage.getItem("EXPENSE_PAGE_FILTERS");
  return item ? JSON.parse(item) : initialValue;
};

class ExpensePage extends Component {
  batchLoadExpenses = debounce(() => {
    this.setState({ loading: true }, async () => {
      // const { filters } = this.state;
      const { auth } = this.props;

      const query = {
        employee: [auth.user._id]
      };

      const result = await ExpenseService.loadExpensesByFilters({ ...query });
      this.setState({ expenses: result, loading: false });
    });
  }, 250);

  constructor(props) {
    super(props);

    const filters = {
      employee: null
    };

    this.state = {
      loading: true,
      search: "",
      filters: getFilters(filters),
      filteredUsers: [],
      expenses: [],
      defaultPageSize: localStorage.getItem("DEFAULT_PAGE_SIZE_EXPENSE_LIST")
        ? parseInt(localStorage.getItem("DEFAULT_PAGE_SIZE_EXPENSE_LIST"))
        : 10
    };
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (this.state.filters.employee !== nextProps.auth.user._id) {
      this.setState((prev) => ({
        ...prev,
        filters: {
          employee: nextProps.auth.user._id
        }
      }));
      this.batchLoadExpenses();
    }
    if (
      Array.isArray(nextProps.expenses) &&
      nextProps.expenses.length > 0 &&
      this.state.expenses.length === 0
    ) {
      this.setState({ expenses: nextProps.expenses });
    }
  }

  componentDidMount = async () => {
    const { actions, departments } = this.props;
    this.props.actions.loadExpensesByEmployeeId(this.props.auth.user._id);
    if (!departments.length) actions.loadContracts();
  };

  onPageSizeChange = (pageSize) => {
    localStorage.setItem("DEFAULT_PAGE_SIZE_EXPENSE_LIST", pageSize);
  };

  onClickAdd = () => {
    this.props.history.push("/app/expenses/add");
  };

  onClickView = (id) => {
    this.props.history.push(`/app/expenses/${id}`);
  };

  onClickDelete = (expenseId) => {
    this.props.actions.requestExpenseId(expenseId);
  };

  handleDelete = () => {
    this.props.actions.deleteExpense(this.props.expenseToDelete);

    const updatedExpenses = this.state.expenses.filter(
      (expense) => expense._id !== this.props.expenseToDelete
    );
    this.setState({ expenses: updatedExpenses });
  };

  filter = (e) => {
    this.setState({ search: e.target.value });
  };

  render() {
    const { isMobile } = this.props;
    const {
      search,
      defaultPageSize,
      // filters,
      // filteredUsers,
      expenses,
      loading
    } = this.state;
    return (
      <div id="expenses">
        <HeaderWrapper
          breadcrumbs={[{ label: "My Expenses" }]}
          onClickAdd={this.onClickAdd}
          onFilter={this.filter}
          isMobile={isMobile}
        />
        {loading ? (
          <div className="loading-loader-load-container">
            <Loading active={loading} />
          </div>
        ) : (
          <div className="content-wrapper">
            <ExpenseList
              search={search}
              expenses={expenses}
              isMobile={isMobile}
              onClickView={this.onClickView}
              onClickDelete={this.onClickDelete}
              defaultPageSize={defaultPageSize}
              onPageSizeChange={this.onPageSizeChange}
            />
          </div>
        )}
        <ConfirmModal
          id="expenseDeleteModal"
          title="Delete Expense"
          body="Are you sure you want to delete this expense?"
          close={this.props.actions.hideModal}
          confirm={this.handleDelete}
        />
      </div>
    );
  }
}

ExpensePage.propTypes = {
  actions: PropTypes.object,
  history: PropTypes.object,
  expenseToDelete: PropTypes.string,
  expenses: PropTypes.array,
  isMobile: PropTypes.bool,
  auth: PropTypes.object,
  departments: PropTypes.array
};

const mapStatesToProps = (state) => ({
  state: state.reducers,
  expenseToDelete: state.reducers.expenseToDelete,
  expenses: state.reducers.expenses,
  auth: state.reducers.auth,
  departments: state.reducers.departments
});

const mapDispatchToProps = (dispatch) => ({
  actions: bindActionCreators(
    {
      ...modalActions,
      ...expenseActions,
      ...userActions,
      ...contractActions
    },
    dispatch
  )
});

export default connect(mapStatesToProps, mapDispatchToProps)(ExpensePage);
